(function() {

    'use strict';

    angular.module('app').config(servicesUrlConfig);

    servicesUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function servicesUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/margins/view/:id', {
            templateUrl: '/templates/pages/services/view.html',
            controller: 'ServicesViewController',
            controllerAs: 'sv',
            params: {
                icon: 'fa fa-pencil',
                parent: 'margins',
                subParent: 'clientServices',
                htmlTitle: 'Connections & Margins',
                pageTitle: 'Connections & Margins'
            }
        }).
        when('/margins/view/:id/preview', {
            templateUrl: '/templates/pages/services/preview.html',
            controller: 'ServiceProfilePreviewController',
            controllerAs: 'sv',
            params: {
                icon: 'fa fa-pencil',
                parent: 'margins',
                subParent: 'clientServices',
                htmlTitle: 'Connections & Margins Preview',
                pageTitle: 'Connections & Margins Preview',
                deepMenuParent: {
                    itemText: 'Connections & Margins',
                    url: '/margins/view/:id',
                }
            }
        }).
        when('/margins/new', {
            templateUrl: '/templates/pages/services/view.html',
            controller: 'ServicesViewController',
            controllerAs: 'sv',
            params: {
                icon: 'fa fa-pencil',
                parent: 'margins',
                subParent: 'serviceLinking',
                htmlTitle: 'Connections & Margins',
                pageTitle: 'Connections & Margins'
            }
        });
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();


// WEBPACK FOOTER //
// ./js/urls/services.js